import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormControl } from '@angular/forms';

@Injectable()
export class KatalogSkupinSablonFilterFormService {
  public readonly filterForm = new FormGroup({
    kodSkupinySablon: new UntypedFormControl(null),
    nazevSkupinySablon: new UntypedFormControl(null),
    kodSablony: new UntypedFormControl(null),
    nazevSablony: new UntypedFormControl(null),
    datumVytvoreni: new UntypedFormControl(null),
    datumUkonceni: new UntypedFormControl(null),
    datumPosledniZmeny: new UntypedFormControl(null),
    status: new UntypedFormControl(null),
  });
}
